/**
 * Formatters utility functions
 */

/**
 * Format a CNPJ string with mask (XX.XXX.XXX/XXXX-XX)
 */
export const formatCnpj = (value: string): string => {
  if (!value) return '';

  // Remove non-numeric characters
  const numericValue = value.replace(/\D/g, '');
  // Limit to 14 digits
  const limitedValue = numericValue.slice(0, 14);

  // If empty, return empty string
  if (limitedValue.length === 0) return '';

  // Apply mask: XX.XXX.XXX/XXXX-XX
  return limitedValue
    .replace(/^(\d{2})(\d)/, '$1.$2')
    .replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3')
    .replace(/\.(\d{3})(\d)/, '.$1/$2')
    .replace(/(\d{4})(\d)/, '$1-$2');
};

/**
 * Format a phone number with mask
 * (XX) XXXXX-XXXX for 11-digit numbers (mobile with DDD)
 * (XX) XXXX-XXXX for 10-digit numbers (landline with DDD)
 */
export const formatPhone = (value: string): string => {
  if (!value) return '';

  // Remove non-numeric characters
  const numericValue = value.replace(/\D/g, '');
  // Limit to 11 digits (mobile format with DDD)
  const limitedValue = numericValue.slice(0, 11);

  // If empty, return empty string
  if (limitedValue.length === 0) return '';

  // Apply mask based on length
  if (limitedValue.length > 10) {
    // Mobile format: (XX) XXXXX-XXXX
    return limitedValue.replace(/^(\d{2})(\d)/, '($1) $2').replace(/(\d{5})(\d)/, '$1-$2');
  } else {
    // Landline format: (XX) XXXX-XXXX
    return limitedValue.replace(/^(\d{2})(\d)/, '($1) $2').replace(/(\d{4})(\d)/, '$1-$2');
  }
};

/**
 * Format a CEP (Brazilian postal code) with mask (XXXXX-XXX)
 */
export const formatZipCode = (value: string): string => {
  if (!value) return '';

  // Remove non-numeric characters
  const numericValue = value.replace(/\D/g, '');
  // Limit to 8 digits
  const limitedValue = numericValue.slice(0, 8);

  // If empty, return empty string
  if (limitedValue.length === 0) return '';

  // Apply mask: XXXXX-XXX
  return limitedValue.replace(/^(\d{5})(\d)/, '$1-$2');
};
